module.exports = __webpack_public_path__ + "static/favicon-ed303b0bf1ba43521d5832696458d2eb.ico";